import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCommits: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCommits"><Path d="M12 6C15.1453 6 17.7234 8.42031 17.9775 11.5H22.5C22.7761 11.5 23 11.7239 23 12C23 12.2761 22.7761 12.5 22.5 12.5H17.9775C17.7234 15.5797 15.1453 18 12 18C8.85472 18 6.27661 15.5797 6.02246 12.5H1.5C1.22386 12.5 1 12.2761 1 12C1 11.7239 1.22386 11.5 1.5 11.5H6.02246C6.27661 8.42031 8.85472 6 12 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCommits;
